import React from 'react';
import Link from 'shared/components/Link';
import featureEnabled from 'shared/helper/feature';
import { PRIMARY_BUTTON } from '../components/buttonClasses';
import PlanCard from '../components/PlanCard';
import PricingLayout from '../components/PricingLayout';
import { FEATURE_LIST_TERMS, GROUP_PLAN_URLS } from '../pricingContent';
import usePricingCopy from '../usePricingCopy';
import ChinaFreeTrialButton from './ChinaFreeTrialButton';
import useChinaPlanPricing from './useChinaPlanPricing';
var CHINA_PLANS = [{
  id: 'premium',
  planGroup: 'editingOnly',
  analyticsName: 'Rubriq Premium',
  cartPath: '/rubriq/subscribe/cart/editing',
  featuresTerm: FEATURE_LIST_TERMS.premium,
  offersFreeTrial: true
}, {
  id: 'translation',
  planGroup: 'premiumWithTranslation',
  analyticsName: 'Rubriq Premium with Translation',
  cartPath: '/rubriq/subscribe/cart/translation',
  featuresTerm: FEATURE_LIST_TERMS.translation,
  isPopular: true,
  featureFlag: 'rubriq_china_cart_edit_only_plan'
}];
var ChinaPricingPage = function ChinaPricingPage(_ref) {
  var hasActivePlan = _ref.hasActivePlan,
    freeTrialExpiration = _ref.freeTrialExpiration;
  var _usePricingCopy = usePricingCopy(),
    page = _usePricingCopy.page,
    plans = _usePricingCopy.plans;
  var _useChinaPlanPricing = useChinaPlanPricing(),
    getAnnualPricing = _useChinaPlanPricing.getAnnualPricing,
    getOneTimePricing = _useChinaPlanPricing.getOneTimePricing;
  var canStartFreeTrial = !featureEnabled('rubriq_cardless_free_trial') && !freeTrialExpiration && !hasActivePlan;
  var renderPlanCard = function renderPlanCard(_ref2) {
    var id = _ref2.id,
      planGroup = _ref2.planGroup,
      analyticsName = _ref2.analyticsName,
      cartPath = _ref2.cartPath,
      featuresTerm = _ref2.featuresTerm,
      isPopular = _ref2.isPopular,
      offersFreeTrial = _ref2.offersFreeTrial;
    var copy = plans[id];
    var _getAnnualPricing = getAnnualPricing(planGroup),
      plan = _getAnnualPricing.plan,
      price = _getAnnualPricing.price,
      yearlySavings = _getAnnualPricing.yearlySavings;
    return /*#__PURE__*/React.createElement(PlanCard, {
      key: id,
      title: copy.title,
      popularBadge: isPopular && page.popular,
      pill: copy.pill,
      price: price,
      period: page.perYear,
      savingsNote: yearlySavings && page.savings(yearlySavings),
      featuresPrefix: copy.featuresPrefix,
      featuresTerm: featuresTerm,
      action: /*#__PURE__*/React.createElement("div", {
        className: "pricing-actions d-flex flex-column"
      }, /*#__PURE__*/React.createElement(Link, {
        className: PRIMARY_BUTTON,
        to: cartPath
      }, copy.buttonLabel), offersFreeTrial && canStartFreeTrial && /*#__PURE__*/React.createElement(ChinaFreeTrialButton, {
        productName: analyticsName,
        price: plan === null || plan === void 0 ? void 0 : plan.price
      }, page.freeTrial))
    });
  };
  return /*#__PURE__*/React.createElement(PricingLayout, {
    planCards: CHINA_PLANS.filter(function (_ref3) {
      var featureFlag = _ref3.featureFlag;
      return !featureFlag || featureEnabled(featureFlag);
    }).map(renderPlanCard),
    groupUrl: GROUP_PLAN_URLS.china,
    plagiarism: featureEnabled('china_use_ithenticate_report') && {
      price: getOneTimePricing('plagiarism')
    }
  });
};
export default ChinaPricingPage;